module.exports = __webpack_public_path__ + "static/media/reward-duplicate.6d4cba3f.png";